import { jsx as e } from "react/jsx-runtime";
import { useTheme as D, Chip as s, Avatar as N, alpha as v } from "@mui/material";
import { l as a, m as l, p as w, s as F, k as g } from "../../../index-DVHhaa_b.js";
import { stripHtmlAndDecode as L } from "../../../helpers/strings.js";
import { prettyDate as k } from "../../../helpers/dates.js";
const q = ({ Category: f, Note: h, NoteDate: u, Updated: n, StaffID: p, StaffFirstname: y, StaffSurname: C, Attachments: m, EventTitle: c, EventDate: d, onClick: I, hideIcon: T = !1 }) => {
  const $ = D(), b = L(h, { allowLinks: !0, allowIframes: !0 }), { Colour: i, Caption: x, Priority: z } = f;
  let r = $.palette.primary.main;
  i && (r = i.startsWith("#") ? i : `#${i}`);
  let o = [];
  return p && o.push(/* @__PURE__ */ e(g, { size: "small", staffId: p, label: `${y} ${C}` }, "staffid")), z === 1 && o.push(/* @__PURE__ */ e(s, { size: "small", color: "error", label: "Important", icon: /* @__PURE__ */ e(a, { iconType: l.Priority }) }, "important")), d && c && o.push(/* @__PURE__ */ e(s, { size: "small", color: "info", label: `${c} ${d.toLocaleDateString()}`, icon: /* @__PURE__ */ e(a, { iconType: l.Calendar }) }, "event")), n && o.push(/* @__PURE__ */ e(s, { size: "small", variant: "outlined", label: `Updated: ${k(n)}`, icon: /* @__PURE__ */ e(a, { iconType: l.Calendar }) }, "updated")), m && m.forEach((t) => o.push(/* @__PURE__ */ e(w, { size: "small", fileName: t.FullName, fileId: t.FileID, extension: t.Ext, download: !0 }, t.FileID))), /* @__PURE__ */ e(
    F,
    {
      itemType: "lessonnote",
      title: x,
      description: b,
      avatar: T ? void 0 : /* @__PURE__ */ e(N, { variant: "rounded", sx: { height: 30, width: 30, bgcolor: v(r, 0.15), color: r }, children: /* @__PURE__ */ e(a, { iconType: l.Note }) }),
      date: u,
      chips: o,
      onClick: I
    }
  );
};
export {
  q as NoteItem
};
//# sourceMappingURL=note.js.map
